.dialog {
  width: 100%;
  max-width: var(--width-prose);
  /* The `* { margin: 0 }` reset in base.css also hits the UA's
     `dialog:modal { margin: auto }`, which is what centres it. */
  margin: auto;
  padding: 0;
  border: 1px solid var(--border);
  border-radius: var(--radius-lg);
  background: var(--surface-overlay);
  color: var(--text-primary);
  box-shadow: var(--shadow-lg);
}

.dialog::backdrop {
  background: var(--overlay-scrim);
}

.wide {
  max-width: var(--width-wide);
}

/* On a phone it is a sheet: a centred box with the keyboard open is unusable. */
@media (max-width: 640px) {
  .dialog {
    max-width: 100%;
    margin: auto auto 0;
    border-radius: var(--radius-lg) var(--radius-lg) 0 0;
  }
}

.body {
  display: flex;
  flex-direction: column;
  max-height: 85dvh;
}

.header {
  display: flex;
  gap: var(--space-3);
  align-items: center;
  justify-content: space-between;
  padding: var(--space-4) var(--space-5);
  border-bottom: 1px solid var(--border);
}

.content {
  flex: 1;
  padding: var(--space-5);
  overflow-y: auto;
}

.footer {
  display: flex;
  gap: var(--space-3);
  justify-content: flex-end;
  padding: var(--space-4) var(--space-5);
  border-top: 1px solid var(--border);
  background: var(--surface-sunken);
}
